export default "__VITE_ASSET__1472133a__"